<template>
    <el-dialog
        :title="$t('message.cdepartment.diaTitle')"
        :visible="dialogVisible"
        @close="handleClose"
        width="45%"
        class="department_dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <slot name="form"></slot>
        <template #footer>
            <div>
                <el-button
                    type="primary"
                    @click="handleModify">
                    <span>{{$t("public.confirmBtn")}}</span>
                </el-button>
                <el-button
                    @click="handleClose">
                    <span>{{$t("public.cancelBtn")}}</span>
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: mapState({
        dialogVisible: state => state.dialogVisible
    }),
    methods: {
        handleClose(){ // 关闭模态框
            this.$emit('handleClose');
        },
        handleModify(){ // 确定按钮
            this.$emit('handleModify', this.handleClose);
        }
    },
}
</script>

<style scoped>
.department_dialog>>>.el-dialog__body{
    padding-bottom: 0;
}
</style>
